/**
stats
*/


<template>
    <div>
        <ul class="rc-info-tabs">
            <li v-for="(tab, key) in tabRefs" v-bind:class="{'active': tab.visible, 'striped-link-on': tab.visible, 'striped-link': !tab.visible}">
                <a v-on:click.prevent="switchTab(key)" role="button" tabindex="0">
                    {{ tab.tabName }}
                </a>
            </li>
        </ul>

        <div>
            <div class="stats-tab-content" v-if="tabRefs.overview.visible">
                <stats-overview v-bind:state-change="stateChange"/>
            </div>
            <div class="stats-tab-content" v-if="tabRefs.mpas.visible">
                <stats-mpas-byelaws v-bind:state-change="stateChange"/>
            </div>
            <div class="stats-tab-content" v-if="tabRefs.habitats.visible">
                <stats-habitats v-bind:state-change="stateChange"/>
            </div>
            <div class="stats-tab-content" v-if="tabRefs.fishing.visible">
                <stats-fishing v-bind:state-change="stateChange"/>
            </div>
            <div class="stats-tab-content" v-if="tabRefs.condition.visible">
                <stats-condition v-bind:state-change="stateChange"/>
            </div>
        </div>
    </div>
</template>


<script>
import store from "../store/reality-check-store";
import StatsOverview from "./stats-overview.vue";
import StatsMpasByelaws from "./stats-mpas-byelaws.vue";
import StatsHabitats from "./stats-habitats.vue";
import StatsFishing from "./stats-fishing.vue";
import StatsCondition from "./stats-condition.vue";

export default {
    name: "stats",
    components: {
        StatsOverview, StatsMpasByelaws, StatsHabitats, StatsFishing, StatsCondition
    },
    store,
    props: {},
    data: function () {
        return {
            tabRefs: {
                "overview": {
                    tabName: "Overview", visible: true
                },
                "mpas": {
                    tabName: "MPAs and byelaws", visible: false
                },
                "habitats": {
                    tabName: "Broad-scale habitats", visible: false
                },
                "fishing": {
                    tabName: "Demersal fishing activity", visible: false
                },
                "condition": {
                    tabName: "MPA Recovery Statistics", visible: false
                }
            },
            stateChange: 1
        }
    },
    methods: {
        switchTab: function (newTab) {
            for (let key in this.tabRefs) {
                this.tabRefs[key].visible = key === newTab;
            }

            this.$nextTick(function () {
                this.stateChange = Date.now();
            })
        }
    },
    computed: {},
    watch: {},
    mounted: function () {
        this.$store.dispatch("loadStats", mparc.stats)
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .stats-tab-content {
        width: 100%;
        max-width: 1000px;
    }

    .chart-title {
        margin: 0 0 20px 0;
        font-size: 90% !important;
    }
</style>